import { expensesForExport, importExpensesFromFile } from "../utils/importExport";

export const expenseService = {
  exportRows: expensesForExport,
  importFromFile: importExpensesFromFile
};
